<template>
  <div :class="{isOpen:isOpen}" class="mc-modal mc-modal--h100" id="selectOffices">
    <div class="mc-modal__outer">
      <div class="mc-modal__inner">
        <div class="mc-modal__heading">
          <button @click="$emit('close')" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
            </svg>
          </button>
          <div class="mc-modal__title">
            Выбрать пункт самовывоза
          </div>
        </div>
        <div class="mc-modal__body">
          <div class="mc-delivery">
            <section class="mc-delivery__tabs mc-tabs mc-tabs--fr">
              <div class="mc-tabs__button-wrapper">
                <ul class="mc-tabs__list">
                  <li @click="tabShow = 1" class="mc-tabs__item" :class="{isActive: tabShow == 1}" id="tab1">
                    <button class="mc-tabs__button js-button-tab" data-name="content1" type="button">
                      На карте
                    </button>
                  </li>
                  <li @click="tabShow = 2" class="mc-tabs__item" :class="{isActive: tabShow == 1}" id="tab2">
                    <button class="mc-tabs__button js-button-tab" data-name="content2" type="button">
                      Списком
                    </button>
                  </li>
                  <li class="mc-tabs__glide" :style="tabGlide"></li>
                </ul>
              </div>
              <div class="mc-tabs__static">
                <div class="mc-form__search-wrapper">
                  <div class="mc-form__search">
                    <input @input="searchPoint" class="mc-form__search-input js-input-search" id="selectOfficesSearch" placeholder="Искать по адресу" type="text" v-model="search">
                    <button class="mc-form__search-button-delete js-button-delete" type="button">
                      <svg class="mc-form__search-icon-delete" width="20" height="20" viewBox="0 0 20 20">
                        <use xlink:href="/assets/svg/sprite.svg#icon-cross-1"></use>
                      </svg>
                    </button>
                  </div>
                  <div class="mc-form__search-result mc-search-result">
                    <div class="mc-search-result__inner">
                      <ul class="mc-search-result__list">
                        <li class="mc-search-result__item">
                          <a class="mc-search-result__link" href="#">
                            ул. Марата 8
                          </a>
                        </li>
                        <li class="mc-search-result__item">
                          <a class="mc-search-result__link" href="#">
                            ул. Марата 8
                          </a>
                        </li>
                        <li class="mc-search-result__item">
                          <a class="mc-search-result__link" href="#">
                            ул. Марата 8
                          </a>
                        </li>
                        <li class="mc-search-result__item">
                          <a class="mc-search-result__link" href="#">
                            ул. Марата 8
                          </a>
                        </li>
                        <li class="mc-search-result__item">
                          <a class="mc-search-result__link" href="#">
                            Москва
                          </a>
                        </li>
                        <li class="mc-search-result__item">
                          <a class="mc-search-result__link" href="#">
                            Москва
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mc-tabs__body-wrapper">
                <div class="mc-tabs__body" :class="{isActive: tabShow == 1}" id="content1">
                  <div
                      v-if="openMarker"
                      class="popup"
                  >
                    <button @click="openMarker=false" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
                      <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
                        <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
                      </svg>
                    </button>
                    <div class="mc-delivery__item">
                      <div class="mc-delivery-card__body">
                        <div class="mc-delivery-card__title">
                          {{openMarker.Address}}
                        </div>
                        <button @click="$emit('close', openMarker, $props.city)" class="mc-button simulated-hover" type="button">
                                            <span class="mc-button__text">
                                                Выбрать
                                            </span>
                        </button>
                        <ul class="mc-delivery-card__info-list">
                          <li class="mc-delivery-card__info-item">
                            Режим работы: {{openMarker.WorkTime}}
                          </li>
                          <li class="mc-delivery-card__info-item">
                            Телефон: {{openMarker.Phone}}
                          </li>
                          <li v-if="openMarker.Dressing" class="mc-delivery-card__info-item">
                            <img class="mc-delivery-card__info-icon" src="/assets/svg/icon-dress.svg" width="15" height="15" alt="">
                            Есть примерочная
                          </li>
                          <li class="mc-delivery-card__info-item mc-delivery-card__info-item--muted">
                            {{ openMarker.Note }}
                          </li>
                        </ul>
                      </div>

                    </div>
                  </div>
                  <yandex-map class="mc-delivery__map"
                              ref="map"
                              v-model="map"
                              real-settings-location
                              :settings="{location: {...location}}"
                              width="100%"
                              height="500px"
                  >
                    <yandex-map-default-scheme-layer/>
                    <yandex-map-default-features-layer/>
                    <yandex-map-clusterer zoom-on-cluster-click>
                    <template v-if="pickupPointLoaded">
                      <template v-for="(item, index) in pickupPoint"  :key="index">
                        <yandex-map-default-marker v-if="false" :settings="{ coordinates: [item.cX, item.cY], onClick: () => {    },  }">
                        </yandex-map-default-marker>
                        <yandex-map-marker :settings="{ coordinates: [item.cX, item.cY]   }">
                          <div @click="openMarkerHandler(item)"
                              class="marker"
                          >



                          </div>
                        </yandex-map-marker>
                      </template>
                    </template>
                      <template #cluster="{ length }">
                        <div
                            class="cluster fade-in"
                        >
                          {{ length }}
                        </div>
                      </template>
                    </yandex-map-clusterer>
                  </yandex-map>
                </div>
                <div class="mc-tabs__body" :class="{isActive: tabShow == 2}" id="content2">
                  <ul class="mc-delivery__list">

                    <li v-for="(item, index) in pickupPoint" class="mc-delivery__item mc-delivery-card">
                      <div class="mc-delivery-card__body">
                        <div class="mc-delivery-card__title">
                          {{item.Address}}
                        </div>
                        {{item.cX}}
                        {{item.cY}}
                        <ul class="mc-delivery-card__info-list">
                          <li class="mc-delivery-card__info-item">
                            Режим работы: {{item.WorkTime}}
                          </li>
                          <li class="mc-delivery-card__info-item">
                            Телефон: {{item.Phone}}
                          </li>
                          <li v-if="item.Dressing" class="mc-delivery-card__info-item">
                            <img class="mc-delivery-card__info-icon" src="/assets/svg/icon-dress.svg" width="15" height="15" alt="">
                            Есть примерочная
                          </li>
                          <li class="mc-delivery-card__info-item mc-delivery-card__info-item--muted">
                            {{ item.Note }}
                          </li>
                        </ul>
                      </div>
                      <button @click="$emit('close', item, $props.city)" class="mc-button simulated-hover" type="button">
                                            <span class="mc-button__text">
                                                Выбрать
                                            </span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  YandexMap,
  YandexMapDefaultSchemeLayer,
  YandexMapDefaultFeaturesLayer,
  YandexMapDefaultMarker,
  YandexMapMarker,
  YandexMapClusterer,
  getLocationFromBounds
} from 'vue-yandex-maps';
window.getLocationFromBounds = getLocationFromBounds;
export default {
  mixins: [getLocationFromBounds],
  props: {
    isOpen: false,
    city: false
  },
  data:() => ({
    map: false,
    location: {center: [35, 56], zoom:9},
    showModalCity: false,
    tabShow: 1,
    tabGlide: {
      left: 0,
      top: 0,
      width: 0,
      height: 0,
    },
    openMarker: false,
    search: ''
  }),
  computed: {
    ...mapGetters([
      'pickupPointLoading',
      'pickupPointError',
      'pickupPointLoaded'
    ]),
    pickupPoint() {
      if (this.search) {
        let result = [];
        for (let i in this.$store.getters.pickupPoint) {
          if (this.$store.getters.pickupPoint[i].Address.toLowerCase().includes(this.search.toLowerCase()))
            result.push(this.$store.getters.pickupPoint[i])
        }
        return result;
      }
      return this.$store.getters.pickupPoint;
    }
  },
  async created() {
    if (this.$props.city) {
      await this.fetchPickupPoint(this.$props.city);
      for (let i in this.pickupPoint) {
        this.location = {
          center: [this.pickupPoint[i]['cX'], this.pickupPoint[i]['cY']],
          zoom: 10,
        }
        break;
      }
    /*  let bounds = [];
      for (let i in this.pickupPoint) {
        bounds.push([this.pickupPoint[i]['cX'], this.pickupPoint[i]['cX']])
      }
      console.log(bounds)
      debugger;
      let map = this.map.addChild;
      let loc = await getLocationFromBounds({
        bounds: bounds,
        map: this.map,
        roundZoom: true, //Выполнить округление зума через Math.floor
        comfortZoomLevel: true, //Добавить "пространства" в зум
      });
      debugger;*/
      /*console.log( center,
          zoom)
      this.location = {
        center: center,
        zoom: zoom,
      }
     console.log(this.location)*/
    }
  },
  mounted() {
    setTimeout(() => {
      this.setTabActive(1);
    },1000)
  },
  watch: {
    tabShow(newValue, oldValue) {
      this.setTabActive(newValue);
    },
    id(newValue, oldValue) {
      /*if (newValue)
      this.fetchpickupPoint(newValue);*/
    }
  },
  emits: ['close'],
  methods: {
    ...mapActions([
      'fetchPickupPoint'
    ]),
    getPositionRelativeToParent(element) {
      var parent = element.parentElement;
      var parentRect = parent === null || parent === void 0 ? void 0 : parent.getBoundingClientRect();
      var elementRect = element.getBoundingClientRect();
      return {
        left: elementRect.left - parentRect.left,
        top: elementRect.top - parentRect.top
      };
    },
    setTabActive(newValue) {
      let tabItem = document.getElementById('tab'+newValue);
      let relativePosition = this.getPositionRelativeToParent(tabItem);
      this.tabGlide.left = relativePosition.left + "px";
      this.tabGlide.top = relativePosition.top + "px";
      this.tabGlide.width = tabItem.offsetWidth + "px";
      this.tabGlide.height = tabItem.offsetHeight + "px";
    },
    openMarkerHandler(item)
    {
      this.openMarker = item
      console.log('openMarkerHandler', this.openMarker);
    },
    searchPoint() {

    }
  },
  components: {YandexMap,
    YandexMapDefaultSchemeLayer,
    YandexMapDefaultFeaturesLayer,
    YandexMapDefaultMarker,
    YandexMapMarker,
    YandexMapClusterer}
}
</script>
<style scoped>
.marker-popup {
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  color: black;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
}

.marker {
  background: green;
  display: block;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  cursor: pointer;
  color: #fff;
  width: 30px; height:30px;
  white-space: nowrap;
}

.popup {
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  padding: 10px;
  color: black;
  z-index: 9;
}
.popup .mc-delivery__item {background: #fff;
  border-radius: 10px;}

.cluster {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background: green;
  color: #fff;
  border-radius: 100%;
  cursor: pointer;
  border: 2px solid limegreen;
  outline: 2px solid green;
  text-align: center;
  background:red
}

.fade-in {
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.mc-tabs__body {position: relative;}
.popup .mc-modal__close-button {top:15px; right:15px}
</style>